(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.andersGalleryReady === 'true') return;
    const nav = gallery.querySelector('.anders-product-gallery-nav');
    if (!nav) return;
    gallery.dataset.andersGalleryReady = 'true';

    const items = () => Array.from(gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]'));
    const move = (direction) => {
      const slides = items();
      if (slides.length < 2) return;
      let current = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (current < 0) current = 0;
      const next = direction === 'prev'
        ? (current - 1 + slides.length) % slides.length
        : (current + 1) % slides.length;
      const target = slides[next];
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(target.dataset.mediaId, false);
      } else {
        slides.forEach((slide) => slide.classList.remove('is-active'));
        target.classList.add('is-active');
      }
    };

    nav.addEventListener('click', (event) => {
      const button = event.target.closest('[data-anders-gallery-direction]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      move(button.dataset.andersGalleryDirection);
    });

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') move('prev');
      if (event.key === 'ArrowRight') move('next');
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('media-gallery').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
